import React, { useState } from 'react';
import { connect } from 'react-redux';
import { IconButton, Table, TableBody, TableCell, TableRow } from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import { sentenceCase } from '../../utils/strings';
import MeasurementSelector from '../account/unitPrefs/MeasurementSelector';
import AggregationSelector from './AggregationSelector';

/* eslint-disable camelcase */

const defaultAgg = (measurementId, measurements) => {
  const measurement = measurements[measurementId];
  const dataType = measurement?.units[0].data_type;
  if (dataType != null && dataType !== 'Continuous') {
    return 'max';
  }
  return 'mean';
};

/**
 * A table of aggregation preferences for measurements. Copy-pasta and adapted from UnitPrefsTable
 */
const AggPrefsTable = ({ preferences, measurements, setPreference, deletePreference }) => {
  const [newAgg, setAgg] = useState();
  const [newMeasurement, setMeasurement] = useState();
  return (
    <Table>
      <TableBody>
        <TableRow className="prefs-header">
          <TableCell aria-label="Add" />
          <TableCell>Measurement Type</TableCell>
          <TableCell>Default Aggregation</TableCell>
          <TableCell>Preferred Aggregation</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <IconButton
              color="secondary"
              disabled={!newMeasurement || !newAgg}
              onClick={() => {
                setPreference(newMeasurement, newAgg).then(() => {
                  setMeasurement(null);
                  setAgg(null);
                });
              }}
              size="large"
            >
              <Add />
            </IconButton>
          </TableCell>
          <TableCell>
            <MeasurementSelector
              selected={newMeasurement}
              onChange={(measId) => {
                setMeasurement(measId);
                setAgg(null);
              }}
            />
          </TableCell>
          <TableCell>
            {newMeasurement && sentenceCase(defaultAgg(newMeasurement, measurements))}
          </TableCell>
          <TableCell>
            {newMeasurement && (
              <AggregationSelector
                measurementId={newMeasurement}
                selected={newAgg}
                onChange={setAgg}
              />
            )}
          </TableCell>
        </TableRow>
        {preferences.map(({ measurement_id, agg }) => (
          <TableRow key={measurement_id}>
            <TableCell>
              <IconButton onClick={() => deletePreference(measurement_id)} size="large">
                <Delete />
              </IconButton>
            </TableCell>
            <TableCell>{measurements[measurement_id]?.name}</TableCell>
            <TableCell>{sentenceCase(defaultAgg(measurement_id, measurements))}</TableCell>
            <TableCell>
              <AggregationSelector
                measurementId={measurement_id}
                selected={agg}
                onChange={(a) => setPreference(measurement_id, a)}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default connect(
  ({
    entities: {
      measurements: { byId },
    },
  }) => ({ measurements: byId })
)(AggPrefsTable);
